<div class="toast-message" *ngIf="!hideNotification" [class.hide]="hideNotification" [class.slideInDown]="!hideNotification">
    <div class="toast-message-content d-flex">
        <div class="toast-message-icon">
            <img src="/assets/icons/notifyicon.png" alt="alert-icon" />
        </div>
        <div class="toast-message-text">
            <p [innerHTML]="notificationMessage"></p>
        </div>
        <div class="toast-message-close">
            <img src="/assets/icons/close.svg" alt="close-icon" (click)="hideNotificationMessage(notificationId)" />
        </div>
    <span></span>
    </div>
</div>
